import { useQuery } from 'react-query';
import paths from 'API/paths';
import axiosInstance from 'Services/axiosConfig';
import { Feature } from 'Store/stateInterfaces';


interface GetAllFeatures{
  pageNumber?:number;
  pageSize?:number;
  query:string;
}

const getAllFeatures = async (payload:GetAllFeatures) => {
  try {
    const url = paths.getAllFeatures();
    const response = await axiosInstance.post(url, {input: payload});
    const features = response?.data?.data?.features?.result;

    return Array.isArray(features) ? features as Feature [] : [];
  } catch (error) {
    return Promise.reject(error);
  }
  
};



export const useGetAllFeatures = (
payload:GetAllFeatures,
    options?: {
      onSuccess?: (data: Feature[]) => void;
    }
  ) => {
    return useQuery(
      ['get-all-features', payload],
      () => getAllFeatures(payload),
      {
        enabled: false,
        ...options,
      }
    );
  };
  